import {
	call,
	put,
	takeEvery
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import EventFactory from "../../Entity/Factories/EventFactory";

export default function* remindersSaveList(action: ActionInterface): any {
  try {
		let request = "events?event_type_ids=3&is_snoozed=0&removed=0";

    const res = yield call(Http.get, request);
    const reminders = res.data.events.rows.map(event => {
      return EventFactory.create(event);
    });

    const payload: any = {
      reminders: reminders
		};

    yield put({
      type: Constants.GLOBAL_REMINDERS_SAVE_LIST_SUCCESS,
      payload: {...payload}
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, reminders);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchRemindersSaveList() {
  yield takeEvery(Constants.GLOBAL_REMINDERS_SAVE_LIST, remindersSaveList);
}
